import {
  init_react_import
} from "./chunk-65BGW52G.mjs";

// theme.ts
init_react_import();
import { Color, Typography } from "@persona-id/design-tokens";
var primary = {
  black: Color.PrimaryBlack,
  white: Color.PrimaryWhite,
  brand: Color.PrimaryPurple,
  brand800: Color.CorePurple800,
  brand700: Color.CorePurple700,
  brand600: Color.CorePurple600,
  brand500: Color.CorePurple500,
  brand400: Color.CorePurple400,
  brand300: Color.CorePurple300,
  brand200: Color.CorePurple200,
  brand100: Color.CorePurple100
};
var lightText = {
  primary: Color.TextPrimary,
  secondary: Color.TextSecondary,
  tertiary: Color.CoreSlate800,
  brand: primary.brand,
  inverse: Color.TextInverse,
  disabled: Color.TextDisabled
};
var darkText = {
  primary: Color.TextInverse,
  secondary: Color.CoreSlate500,
  tertiary: Color.CoreSlate800,
  brand: primary.brand,
  inverse: Color.TextPrimary,
  disabled: Color.TextDisabled
};
var lightColorPalette = {
  primary,
  text: lightText,
  background: {
    primary: Color.BackgroundPrimary,
    secondary: Color.BackgroundSecondary,
    active: primary.brand,
    highlight: primary.brand100,
    disabled: Color.BackgroundInputDisabled
  },
  variants: {
    basic: {
      active: Color.BackgroundButtonDefaultActive,
      default: Color.BackgroundButtonDefault,
      highlight: Color.CoreSlate400,
      highlightLight: Color.CoreSlate400,
      highlightDark: Color.CoreSlate700,
      disabled: Color.CoreSlate100,
      text: lightText.primary,
      textDisabled: lightText.disabled
    },
    primary: {
      active: Color.BackgroundButtonPrimaryActive,
      default: Color.BackgroundButtonPrimary,
      highlight: primary.brand200,
      highlightLight: primary.brand100,
      highlightDark: primary.brand200,
      disabled: Color.BackgroundButtonPrimaryDisabled,
      text: lightText.inverse,
      textDisabled: lightText.inverse
    },
    inverse: {
      active: primary.brand100,
      default: primary.white,
      highlight: primary.brand200,
      highlightLight: primary.brand100,
      highlightDark: primary.brand700,
      disabled: primary.white,
      text: lightText.primary,
      textDisabled: lightText.disabled
    },
    danger: {
      active: Color.BackgroundButtonDangerActive,
      default: Color.BackgroundButtonDanger,
      highlight: Color.CoreRed200,
      highlightLight: Color.CoreRed100,
      highlightDark: Color.CoreRed200,
      disabled: Color.BackgroundButtonDangerDisabled,
      text: lightText.inverse,
      textDisabled: lightText.inverse
    },
    caution: {
      active: Color.CoreYellow900,
      default: Color.CoreYellow800,
      highlight: Color.CoreYellow200,
      highlightLight: Color.CoreYellow100,
      highlightDark: Color.CoreYellow200,
      disabled: Color.CoreYellow100,
      text: lightText.inverse,
      textDisabled: lightText.inverse
    },
    success: {
      active: Color.CoreGreen900,
      default: Color.CoreGreen800,
      highlight: Color.CoreGreen200,
      highlightLight: Color.CoreGreen100,
      highlightDark: Color.CoreGreen200,
      disabled: Color.CoreGreen100,
      text: lightText.inverse,
      textDisabled: lightText.inverse
    }
  },
  border: {
    primary: Color.BorderHairline,
    secondary: Color.BorderDivider,
    active: Color.BorderInputActive,
    input: Color.BorderInputDefault,
    disabled: Color.BorderInputDisabled
  }
};
var darkColorPalette = {
  primary,
  text: darkText,
  background: {
    primary: Color.CoreSlate1000,
    secondary: Color.CoreSlate50,
    active: primary.brand,
    highlight: Color.PrimaryWhite,
    disabled: Color.CoreSlate300
  },
  variants: {
    basic: {
      active: Color.BackgroundButtonDefaultActive,
      default: Color.BackgroundButtonDefault,
      highlight: Color.CoreSlate400,
      highlightLight: Color.CoreSlate400,
      highlightDark: Color.CoreSlate900,
      disabled: Color.CoreSlate100,
      text: darkText.primary,
      textDisabled: darkText.disabled
    },
    primary: {
      active: Color.CoreSlate900,
      default: Color.CoreSlate1000,
      highlight: primary.brand200,
      highlightLight: primary.brand100,
      highlightDark: primary.brand200,
      disabled: Color.BackgroundButtonPrimaryDisabled,
      text: primary.white,
      textDisabled: darkText.inverse
    },
    inverse: {
      active: primary.brand100,
      default: primary.white,
      highlight: primary.brand200,
      highlightLight: primary.brand100,
      highlightDark: primary.brand700,
      disabled: primary.white,
      text: darkText.inverse,
      textDisabled: darkText.disabled
    },
    danger: {
      active: Color.BackgroundButtonDangerActive,
      default: Color.BackgroundButtonDanger,
      highlight: Color.CoreRed300,
      highlightLight: Color.CoreRed100,
      highlightDark: Color.CoreRed300,
      disabled: Color.BackgroundButtonDangerDisabled,
      text: darkText.inverse,
      textDisabled: darkText.inverse
    },
    caution: {
      active: Color.CoreYellow900,
      default: Color.CoreYellow800,
      highlight: Color.CoreYellow200,
      highlightLight: Color.CoreYellow100,
      highlightDark: Color.CoreYellow200,
      disabled: Color.CoreYellow100,
      text: darkText.inverse,
      textDisabled: darkText.inverse
    },
    success: {
      active: Color.CoreGreen900,
      default: Color.CoreGreen800,
      highlight: Color.CoreGreen200,
      highlightLight: Color.CoreGreen100,
      highlightDark: Color.CoreGreen200,
      disabled: Color.CoreGreen100,
      text: darkText.inverse,
      textDisabled: darkText.inverse
    }
  },
  border: {
    primary: Color.CoreSlate900,
    secondary: Color.BorderDivider,
    active: Color.BorderInputActive,
    input: Color.BorderInputDefault,
    disabled: Color.BorderInputDisabled
  }
};
var defaultTextSettings = {
  fontFamily: {
    base: "'Rubik', sans-serif",
    mono: "'Lucida Console', Monaco, Consolas, 'Andale Mono', 'Ubunto Mono', monospace"
  },
  display: {
    lg: Typography.DisplayLarge,
    md: Typography.DisplayMedium,
    sm: Typography.DisplaySmall
  },
  heading: {
    lg: Typography.HeadingLarge,
    md: Typography.HeadingMedium,
    sm: Typography.HeadingSmall
  },
  paragraph: {
    lg: Typography.TextLarge,
    lgBold: Typography.TextLargeBold,
    lgLight: Typography.TextLargeLight,
    md: Typography.TextMedium,
    mdBold: Typography.TextMediumBold,
    mdLight: Typography.TextMediumLight,
    mdLink: Typography.TextMediumLink,
    sm: Typography.TextSmall,
    smLink: Typography.TextSmallLink,
    xs: Typography.TextExtraSmall
  }
};
var textSettingsWithMarketingFont = {
  ...defaultTextSettings,
  fontFamily: {
    base: "'Twkeverett web', sans-serif",
    mono: "'Lucida Console', Monaco, Consolas, 'Andale Mono', 'Ubunto Mono', monospace"
  }
};
var defaultElementSettings = {
  borderRadius: "4px",
  height: {
    xl: "128px",
    lg: "56px",
    md: "48px",
    sm: "40px",
    xs: "32px"
  },
  width: {
    md: "228px"
  }
};
var defaultButtonSettings = {
  borderRadius: "4px",
  height: {
    md: "32px",
    sm: "24px"
  }
};
var defaultCardSettings = {
  borderRadius: "8px"
};
var defaultModalSettings = {
  borderRadius: {
    xl: "8px",
    lg: "4px",
    md: "4px"
  },
  width: {
    xl: "1020px",
    lg: "720px",
    md: "520px"
  }
};
var defaultTheme = {
  color: lightColorPalette,
  text: defaultTextSettings,
  element: defaultElementSettings,
  button: defaultButtonSettings,
  card: defaultCardSettings,
  modal: defaultModalSettings
};
var darkTheme = {
  color: darkColorPalette,
  text: defaultTextSettings,
  element: defaultElementSettings,
  button: defaultButtonSettings,
  card: defaultCardSettings,
  modal: defaultModalSettings
};
var marketingFontTheme = {
  color: lightColorPalette,
  text: textSettingsWithMarketingFont,
  element: defaultElementSettings,
  button: defaultButtonSettings,
  card: defaultCardSettings,
  modal: defaultModalSettings
};
var theme_default = defaultTheme;

export {
  darkTheme,
  marketingFontTheme,
  theme_default
};
//# sourceMappingURL=chunk-TAJ3RMB6.mjs.map